// extracted by mini-css-extract-plugin
export default {"flowCard":"flowCard-6377","disabled":"disabled-5b7f"};